import { render, staticRenderFns } from "./ItemIntimacao.vue?vue&type=template&id=3e13d2f2"
import script from "./ItemIntimacao.vue?vue&type=script&lang=js"
export * from "./ItemIntimacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports